import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	paymentType: null,
	error: "",
	loading: false,
};

// ADD_paymentType
export const addPaymentType = createAsyncThunk(
	"paymentType/addPaymentType",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `paymentType`,
				data: {
					...values,
				},
			});
			toast.success("Payment Type added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Payment Type try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_paymentType
export const deletePaymentType = createAsyncThunk(
	"paymentType/deletePaymentType ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `paymentType/${id}`,
			});

			toast.success("Payment Type deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Payment Type try again");
			console.log(error.message);
		}
	}
);

// paymentTypeS
export const getAllPaymentType = createAsyncThunk(
	"paymentType/getAllPaymentType",
	async () => {
		try {
			const { data } = await axios.get(`paymentType/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updatePaymentType = createAsyncThunk(
	"paymentType/updatePaymentType",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `paymentType/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Payment Type updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Payment Type try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const paymentTypeSlice = createSlice({
	name: "paymentType",
	initialState,
	reducers: {
		clearPaymentType: (state) => {
			state.paymentType = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllPaymentType ======

		builder.addCase(getAllPaymentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllPaymentType.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllPaymentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addPaymentType  ======

		builder.addCase(addPaymentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addPaymentType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addPaymentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for PaymentType ======

		builder.addCase(updatePaymentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updatePaymentType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updatePaymentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deletePaymentType  ======

		builder.addCase(deletePaymentType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deletePaymentType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deletePaymentType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default paymentTypeSlice.reducer;
export const { clearPaymentType } = paymentTypeSlice.actions;
